export const NFK_LOCATIONS: Locations[] = [
    { theaters: ["Arendal kino"], location: "Arendal", label: "Arendal", firmId: 53 },
    { theaters: ["Asker kino"], location: "Asker", label: "Asker", firmId: 4 },
    { theaters: ["Askim kino"], location: "Askim", label: "Askim", firmId: 19 },
    { theaters: ["Farsund kino"], location: "Farsund", label: "Farsund", firmId: 75 },
    { theaters: ["KinoCity"], location: "Drammen", label: "Drammen", firmId: 14 },
    { theaters: ["Kristiansand kino"], location: "Kristiansand S", label: "Kristiansand S", firmId: 2 },
    { theaters: ["Kristiansund kino"], location: "Kristiansund", label: "Kristiansund", firmId: 32 },
    { theaters: ["Halden kino"], location: "Halden", label: "Halden", firmId: 20 },
    { theaters: ["Horten kino"], location: "Horten", label: "Horten", firmId: 91 },
    { theaters: ["Honefoss kinosenter"], location: "Honefoss", label: "Honefoss", firmId: 68 },
    { theaters: ["Sarpsborg Kino"], location: "Sarpsborg", label: "Sarpsborg", firmId: 192 },
    { theaters: ["Kilden Kino"], location: "Tonsberg", label: "Tonsberg", firmId: 109 },
    { theaters: ["Lagunen"], location: "Bergen", label: "Bergen", firmId: 171 },
    {
        theaters: ["Colosseum", "Gimle", "Klingenberg", "Ringen", "Saga", "Symra", "Vika"],
        location: "Oslo",
        label: "Oslo",
        firmId: 3,
    },
    { theaters: ["Verdal kino"], location: "Verdal", label: "Verdal", firmId: 37 },
];

type Locations = {
	theaters: string[];
	location: string;
	label: string;
	firmId: number;
};
